/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_ACTION = '/dynamicpassport';

/**
 * calculateDynamicPassport
 * url - /checkout/{apiversion}/cart/{cartId}/dynamicpassport?brand={brandId}&passportItem={passportItem}
 *
 * @param {Object} args
 * @param {string} args.env
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 * @param {String} args.passportItem
 */
const calculateDynamicPassport = ({
    env, jwtToken, cartId, passportItem,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    const payload = {};
    if (passportItem) {
        payload.passportItem = passportItem;
    }

    const resourcePage =  `${RESOURCE_PAGE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_ACTION}`;

    return restClient.getRequest(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default calculateDynamicPassport;
